import { useState } from "react";
import { Box, Container, Paper, Typography, Button, Alert, CircularProgress } from "@mui/material";
import { useCreateEcommercePublic } from "../../client/hooks/marketplace/marketplace.queries";
import { useCheckoutForm } from "./hooks/useCheckoutForm";
import CompanyForm from "./components/CompanyForm";
import UserForm from "./components/UserForm";
import SuccessScreen from "./components/SuccessScreen";
import etiquetasImage from "../../assets/etiquetas/etiquetas_media_png.png";

const TrialCheckout = () => {
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const { formData, errors, handleChange, validateForm } = useCheckoutForm();

  const { data, isLoading, error, refetch } = useCreateEcommercePublic(
    formData,
    { plan_type: "trial", source: "landing" },
    submitAttempted
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      setSubmitAttempted(true);
      refetch();
    }
  };


  if (data && !error) {
    return (
      <SuccessScreen
        title="Trial Ativado com Sucesso!"
        message="Sua conta trial foi criada. Aproveite 15 dias de acesso completo!"
      />
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f59e0b 0%, #ef4444 50%, #dc2626 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
        boxShadow: "inset 0 0 50px rgba(0, 0, 0, 0.3), inset 0 0 100px rgba(255, 255, 255, 0.1)",
      }}
    >
      <Box
        component="img"
        src={etiquetasImage}
        alt="Background"
        sx={{
          position: "absolute",
          top: "10%",
          right: "5%",
          width: "300px",
          height: "auto",
          opacity: 0.1,
          transform: "rotate(15deg)",
          display: { xs: "none", lg: "block" },
          filter: "blur(1px) drop-shadow(0 0 15px rgba(255, 255, 255, 0.2))",
        }}
      />
      
      <Container maxWidth="md" sx={{ position: "relative" }}>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography 
            variant="h2" 
            fontWeight="bold" 
            sx={{ 
              color: "white",
              fontSize: { xs: "2rem", md: "2.8rem" },
              mb: 2,
              textShadow: "0 4px 20px rgba(0,0,0,0.3)"
            }}
          >
            Teste Grátis o Sistema de Etiquetas
          </Typography>
          <Typography 
            variant="h5" 
            sx={{ 
              color: "rgba(255,255,255,0.9)",
              mb: 4,
              fontWeight: 300,
              fontSize: { xs: "1.2rem", md: "1.5rem" }
            }}
          >
            15 dias de acesso completo ao sistema de etiquetas
          </Typography>
        </Box>

        <Box sx={{ 
          maxWidth: "600px", 
          mx: "auto",
          position: "relative"
        }}>
          <Paper elevation={20} sx={{ p: 5, borderRadius: 4, position: "relative", overflow: "hidden" }}>
            <Box sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              background: "linear-gradient(90deg, #f59e0b 0%, #ef4444 50%, #dc2626 100%)"
            }} />
            
            <Typography variant="h5" fontWeight="bold" gutterBottom textAlign="center" sx={{ mt: 1 }}>
              Acesso Premium Completo
            </Typography>
            
            <Box sx={{ 
              display: "flex",
              justifyContent: "center",
              gap: 2,
              mb: 4,
              flexWrap: "wrap"
            }}>
              <Box sx={{ 
                textAlign: "center", 
                p: 2, 
                backgroundColor: "#fef3c7", 
                borderRadius: 2,
                minWidth: "150px"
              }}>
                <Typography variant="body2" fontWeight="bold" color="#f59e0b">
                  🏷️ Etiquetas Completas
                </Typography>
              </Box>
              <Box sx={{ 
                textAlign: "center", 
                p: 2, 
                backgroundColor: "#fecaca", 
                borderRadius: 2,
                minWidth: "150px"
              }}>
                <Typography variant="body2" fontWeight="bold" color="#dc2626">
                  🔗 Integrações Ilimitadas
                </Typography>
              </Box>
            </Box>

              {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                  {error?.response?.data?.msg || "Erro ao criar conta trial. Tente novamente."}
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <CompanyForm formData={formData} errors={errors} handleChange={handleChange} />
                  <UserForm formData={formData} errors={errors} handleChange={handleChange} />
                  
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    size="large"
                    disabled={isLoading}
                    sx={{
                      mt: 2,
                      py: 1.5,
                      fontSize: "1.1rem",
                      fontWeight: "bold",
                      background: "linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)",
                      "&:hover": {
                        background: "linear-gradient(135deg, #e55a2b 0%, #e8851a 100%)",
                      },
                    }}
                  >
                    {isLoading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Iniciar Trial de 15 Dias"
                    )}
                </Button>
              </Box>
            </form>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default TrialCheckout;